import { DrawerObject } from '@/components/drawer/drawer.types';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { DynamicForm } from '@/components/form-builder/form-builder.types';
import { ActivityRepository } from '@/store/activity-state/activity-state.repository';

interface IgetActivityAddDrawerObjectProps {
  store?: ActivityRepository;
  formObject?: DynamicForm;
  toggleVisibility?: () => void;
  action?: () => void;
}

export const getActivityAddDrawerObject = ({ store, formObject, toggleVisibility, action }: IgetActivityAddDrawerObjectProps): DrawerObject => {
  return {
    title: 'settings.activity.add.title',
    description: '',
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject,
      },
    },
    onHide: () => {
      store?.reset();
    },
    actions: [
      {
        label: 'settings.activity.add.add',
        onClick: () => action?.(),
      },
      {
        label: 'settings.activity.add.cancel',
        onClick: () => {
          toggleVisibility?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
